import { MicroFrontendPropsService, ServiceboxMicrofrontendsModule } from '@adnoc/servicebox';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CustomOverlayContainer } from '@lms-approval/shared/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LoaderComponent } from '@lms-approval/shared/ui';

import { DarkModeService, LayoutSpacingService, MobileService } from './services';
import { ResponsiveClassesDirective } from './directives';
import { WrapperViewModeClassesDirective } from './directives/view-mode-classes.directive';
import { PageWrapperComponent } from './components';

@NgModule({
  declarations: [PageWrapperComponent, ResponsiveClassesDirective, WrapperViewModeClassesDirective],
  imports: [BrowserModule, CommonModule, RouterModule, ServiceboxMicrofrontendsModule, LoaderComponent],
  exports: [ResponsiveClassesDirective],
  providers: [
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    MicroFrontendPropsService,
    MobileService,
    LayoutSpacingService,
    DarkModeService,
  ],
})
export class MicroFrontendModule {}
